import { lazy } from './lazyWithRetry';
import { Navigate, Route } from 'react-router-dom';
import { suspense } from './utils';

const AccountCreated = lazy(
  () => import('app/features/auth/feedback/accountCreated'),
);
const EmailSent = lazy(() => import('app/features/auth/feedback/emailSent'));
const PasswordChanged = lazy(
  () => import('app/features/auth/feedback/passwordChanged'),
);
const ForgotPassword = lazy(() => import('app/features/auth/forgotPassword'));
const Login = lazy(() => import('app/features/auth/login'));
const ResetPassword = lazy(() => import('app/features/auth/resetPassword'));
const VerifyEmailAccount = lazy(
  () => import('app/features/auth/verifyEmailAccount'),
);
const VerifyPhoneAccount = lazy(
  () => import('app/features/auth/verifyPhoneAccount'),
);
const ForceChangePassword = lazy(
  () => import('app/features/auth/forceChangePassword'),
);
const AuthLayout = lazy(() => import('app/layout/authLayout'));
const SignUp = lazy(() => import('app/features/auth/signUp'));

export default function AuthRoutes() {
  return (
    <Route element={suspense(<AuthLayout />)}>
      <Route path="/" element={suspense(<Navigate replace to="/login" />)} />
      <Route path="/login" element={suspense(<Login />)} />
      <Route path="/sign-up" element={suspense(<SignUp />)} />
      <Route path="/forgot-password" element={suspense(<ForgotPassword />)} />
      <Route path="/verify-phone" element={suspense(<VerifyPhoneAccount />)} />
      <Route path="/verify-email" element={suspense(<VerifyEmailAccount />)} />
      <Route path="/email-sent" element={suspense(<EmailSent />)} />
      <Route path="/account-created" element={suspense(<AccountCreated />)} />
      <Route path="/password-changed" element={suspense(<PasswordChanged />)} />
      <Route path="/reset-password" element={suspense(<ResetPassword />)} />
      <Route
        path="/set-new-password"
        element={suspense(<ForceChangePassword />)}
      />
    </Route>
  );
}
